export default "__VITE_ASSET__1$hhK9VX__"